export default __webpack_public_path__ + "static/media/results-footprint.e26ffbfc.jpg";